import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { makeStyles } from 'tss-react/mui';
import TextField from '@mui/material/TextField';
import ReportIcon from '@mui/icons-material/Flag';
import { withSnackbar } from 'notistack';
import React, { useState } from 'react';
import { REPORT_POST } from '../../helpers/graphql/curation';
import graphQLClient from '../../helpers/graphQLClient';

const useStyles = makeStyles()(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const ReportDialog = props => {
  const { classes } = useStyles();

  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [details, setDetails] = useState('');

  const { author, permlink, setListenClickAway } = props;

  const handleOpen = () => {
    setListenClickAway(false);
    setOpen(true);
  };

  const handleClose = () => {
    setListenClickAway(true);
    setOpen(false);
  };

  const newNotification = notification => {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      props.enqueueSnackbar(notification.message, { variant });
    }
  };

  const handleReport = () => {
    graphQLClient(REPORT_POST, {
      report: {
        isComment: props.isComment,
        author,
        permlink,
        reason,
        details,
      },
    })
      .then(res => {
        newNotification(res.reportPost);
        if (res.reportPost.success) handleClose();
      })
      .catch(() => {
        newNotification({
          success: false,
          message: 'Report could not be sent. Please try again!',
        });
      });
  };

  return (
    <>
      <MenuItem onClick={handleOpen}>
        <ListItemIcon>
          <ReportIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Report" />
      </MenuItem>
      <Dialog
        maxWidth="lg"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-center" id="form-dialog-title">
          Report Post
        </DialogTitle>
        <DialogContent>
          <FormControl variant="standard" className={classes.formControl}>
            <InputLabel id="demo-simple-select-label">Reason</InputLabel>
            <Select
              variant="standard"
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={reason}
              onChange={event => setReason(event.target.value)}
            >
              <MenuItem value="spam">Spam</MenuItem>
              <MenuItem value="image plagiarism">Image Plagiarism</MenuItem>
              <MenuItem value="plagiarism">Plagiarism / Copy-Paste</MenuItem>
              <MenuItem value="identity theft">Identity Theft</MenuItem>
              <MenuItem value="community guidelines violation">
                Community Guidelines Violation
              </MenuItem>
            </Select>
            <TextField
              variant="standard"
              fullWidth
              multiline
              onChange={event => setDetails(event.target.value)}
              value={details}
              label="Details"
              inputProps={{
                maxLength: 200,
              }}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleReport}
            color="primary"
            variant="contained"
            disabled={!reason}
            autoFocus
          >
            Send Report
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withSnackbar(ReportDialog);
